import { NameEntityResponse } from "../../api-models/response/NameEntityResponse";
import { SewerObjectSummaryResponse } from "../../api-models/response/SewerObjectSummaryResponse";
import { RowItemData } from "../../components/datatable/interfaces";
import { SewerObjectType } from "../../generated/SewerObjects";
import { dateService } from "../date-service/DateService";
import { translationService } from "../translation/TranslationService";
import { getTranslationKeyForType } from "./SewerObject";

export class SewerObjectSummary implements RowItemData {
  id: number;
  name: string;
  type: SewerObjectType;
  openJobsCount: number;
  modified: Date;
  project: NameEntityResponse;
  lastInspection: string;

  constructor(sewerObjectSummaryRow: SewerObjectSummaryResponse) {
    this.id = sewerObjectSummaryRow.id;
    this.name = sewerObjectSummaryRow.name;
    this.openJobsCount = sewerObjectSummaryRow.openJobsCount;
    this.modified = sewerObjectSummaryRow.modified;
    this.type = sewerObjectSummaryRow.type;
    this.project = sewerObjectSummaryRow.project;
    this.lastInspection = sewerObjectSummaryRow.lastInspection;
  }

  get displayValues() {
    return {
      name: { toDisplay: this.name },
      type: {
        toDisplay: translationService.translate(getTranslationKeyForType(this.type)),
      },
      modified: {
        toDisplay: dateService.formatDate(this.modified),
      },
      openJobsCount: { toDisplay: this.openJobsCount },
      lastInspection: {
        toDisplay: this.lastInspection ? dateService.formatDate(this.lastInspection) : null,
      },
      projectName: {
        toDisplay: this.project && this.project.name,
      },
      projectId: { toDisplay: this.project && this.project.id },
    };
  }
}
